<div class="drawer-layout">
    <div class="drawer-content flex-row justify-content-space-between align-items-center">
      <div>
        Filter Alerts
      </div>
      <app-filter-button [appliedFiltersCount]="appliedFiltersCount"
                         [active]="showingFilterBar"
                         (toggled)="toggleFilter()"
      ></app-filter-button>
    </div>

    <div>
      <app-filter-bar
        [origin]="'alerts'"
        [showingFilterBar]="showingFilterBar"
        [useDateFilter]="true"
        [useStormTimeFilter]="true"
        (dateFilterChanged)="onDateFilterChanged($event)"
        [useVehicleFilter]="true"
        (vehicleFilterChanged)="onVehicleFilterChanged($event)"
        [useDriverFilter]="true"
        (driverFilterChanged)="onDriverFilterChanged($event)"
        (appliedFiltersChanged)="appliedFiltersCount = $event"
      >
      </app-filter-bar>
    </div>

	@if (items) {
    <div class="drawer-content">
      @if (items.length > 0) {
        <div class="cards-container">
          @for (item of items; track $index) {
              <app-card-menu-item
                [item]="item"
              ></app-card-menu-item>
          }
        </div>
      }

      @if (items.length === 0) {
        <div class="cards-container">
          <span class="text-muted">There are no alerts for filter set.</span>
        </div>
      }
    </div>
	}
</div>
